export default {
  bank_product: {
    complete_msg:
      '我们衷心感谢您<span>订阅该产品</span>，我们将以更好的产品回报您。',
  },
  enter_amount: '请输入金额。',
  reg_complete: '注册完成',
  subscription_details: '订阅详情',
  select_withdrawal_account: '选择提款账户',
  email_address: '电子邮件地址',
  product_info: '产品信息',
  new_amount: '新金额',
  min_running_amount: '最低执行量 ',
  max_running_amount: '最大执行量 ',
  product_type: '产品类别',
  bank_product_name: '商品名',
  reg_start_date: '注册开始日期',
  reg_end_date: '訂閱結束日期 ',
  exec_start_date: '开始执行的日期 ',
  exec_end_date: '执行结束日期 ',
  basic_info: '基本信息',
  not_applicable: '不适用',
  subscription: '加入',
  service_prepare: '正在准备服务。',
  no_buy_list: '没有购买记录。',
  no_sell_list: '没有销售记录。',
  no_list: '没有清单。',
  locale_name: '中文(中国)',
  Sale_registration: '销售登记',
  apply: '申请',
  status: '状态',
  wallet: '钱包',
  wallet_address: '钱包地址',
  wallet_transfer: '钱包转账',
  buy: '购买',
  sell: '出售',
  all: '所有',
  breakdown: '记录',
  act_buy: '采购',
  act_sell: '卖出',
  asset: '资产',
  select: '选择',
  no_select: '没有选择',
  account: '帐户',
  balance: '余额',
  login: '登录',
  logout: '退出',
  register: '注册',
  select_cancel: '取消选中',
  cancel: '取消',
  modify: '编辑',
  auto_input: '(自动输入)',
  confirm: '确认',
  look_up: '查询',
  password: '密码',
  account_delete: '取消订阅',
  detail: '详细信息',
  list_detail: '详细信息',
  birth: '生日',
  welcome: '欢迎',
  please_login: '请登录',
  confirmation_login: '您可以在登录时进行检查。',
  id: 'ID',
  find_id: '查找ID',
  find_password: '查找密码',
  back: '返回',
  agreement: '协议',
  info_input: '输入信息',
  success: '完成',
  agree_msg: '我同意',
  all_agree: '同意所有条款',
  agree: '同意',
  agreed: '同意',
  confirm_password: '确认密码',
  repeat_password: '请重新输入密码',
  next: '下一步',
  before: '回去',
  register_success: '您已注册',
  verify: '验证',
  retention: '保留',
  allow: '(允许)',
  disallow: '(不允许)',
  upload_btn: '请在此处删除或单击文件。',
  continue_entry: '请在下面输入“ [+:verification]”以继续',
  login_msg_1: '在 ONETETHER上尝试一个与硬币相关的帐户 ！',
  login_msg_2: '请通过我们的ONETETHER使用交易，钱包和服务 ご利用ください。',
  login_msg_3: 'ONETETHER支持所有环境',
  cocofx_register: '注册ONETETHER',
  register_msg_1: '开始注册<br />请同意服务条款',
  register_msg_3: '用ONETETHER账户可以简单的使用所有服务',
  register_msg_all:
    '全部同意包括对必选及选择项目的同意，也可以个别选择同意。拒绝对选择项目同意时，服务也可以使用',
  register_title: '满19周岁以上',
  register_title_2: 'ONETETHER条款',
  register_title_3: 'ONETETHER集成服务条款',
  register_title_4: 'ONETETHER营销杠杆同意',
  register_title_5: '同意收集和使用个人信息',
  register_title_6: '同意收集和使用位置信息',
  register_title_7: '同意收集其他个人资料信息',
  register_title_8: '请输入ONETETHER帐户信息',
  register_title_9: '输入信息',
  register_msg_4:
    '这些条款适用于公司提供的所有服务等。<brxxx />接受这些条款，您可以使用这些服务而无需签订单独的合同',
  required: '[必选]',
  option: '[选择]',
  otp_notice: '状态被激活和停用OTP不可能的。',
  required_check: '请检查所有必填字段',
  check_input: '请输入所有的细节。',
  register_guide: '如何使用ONETETHER',
  register_step1: 'COCO点击付款按钮',
  register_step2: '登录COCO收费',
  register_step3: '支付/充值ONETETHER登录',
  copy: '复制',
  no_account: '没有注册的帐户。',
  inviter_link: '推荐人链接',
  exchange: '货币兑换',
  register_used_account: '注册经常使用的账户',
  security_certification: '安全认证',
  admin_security: '{action}的安全等级是{limit}',
  company: '企业',
  exact_calculation: '调整',
  profile: '会员资料',
  inquiry: '查询',
  inquiry_history: '咨询记录',
  announcement: '通知',
  information: '信息',
  history: '历史',
  registration_date: '登录日',
  pay: '付款',
  detail_search: '详细搜索',
  more_view: '详细查看',
  exchange_store: '交易所',
  external_exchange_store: '外部交易所',
  internal_exchange_store: '内部交流',
  external_transaction: '对外交易',
  internal_transaction: '内部交易',
  favorites: '收藏夹',
  no_favorite_list: '没有收藏夹。',
  no_alias: '没有别名',
  please_enter_account_name: '请输入您的帐户名。',
  variable_amount: '变动金额',
  changes: '变动记录',
  account_transaction_history_inquiry: '账户交易记录查询',
  exchange_application_completed: '货币兑换申请已经完成。',
  choose_how_pay_fee: '选择手续费支付方法',
  free: '免费',
  closing: '闭幕',
  relative_asset_inquiry: '相对资产查询',
  please_enter_relative_account_number: '请输入相对帐号。',
  Please_enter_relative_wallet_address: '请输入相对的钱包地址。',
  memo: '备忘录',
  write_history_memo: '请记录备忘录便于管理',
  re_enter: '重新输入',
  transfer_wallet_account: '转账钱包地址',
  transfer_wallet_inquiry: '汇款钱包查询',
  Kiosk: '自助式服务',
  withdrawable_amount: '可取款金额',
  transferred_assets: '资产转账',
  recipient: '接受者',
  recipient_wallet: '收件人錢包',
  register_user_name_tit: '我们建议您填写安全认证的真实姓名。',
  register_password_tit: '请正确填写常用的电子邮件地址。',
  product_name: '商品名',
  dividend_type: '分红型',
  auto: '自动的',
  manual: '手动的',
  s_usdt_protocol: '选择泰德协议',
  ccf: {
    what_ccf: 'CCF是什么?',
    key_coin: '将加密货币与真实货币联系起来的COCOBNAK的主要硬币',
    ccf_description:
      '将多种加密货币通过直接兑换和C2C交易换算的ONETETHER独有的主要货币,1CCF的价值为USD 1CENT.CCF可以在ONETETHER中更快，更安全地进行购买和交易.',
    how_use_ccf: '怎么使用CCF?',
    cocobank_wallet_transfer:
      '将存储在外部交易所的加密货币资产转移到ONETETHER的钱包.',
    ccf_conversion: '将转移到钱包的加密货币通过直接兑换或C2C交易转换为CCF.',
    direct_exchange_c2c_deal: '直接兑换C2C交易',
    ccf_moved: '将转换的CCF转移到ONETETHER账户.',
    how_use_account_ccf: '请这样使用转移到账户的CCF!',
    freely_purchase_open_market: '请用CCF自由的购买OPEN MARKET的商品吧!',
    free_deposit_withdrawal: '银行内账户可以自由存取款和转账!',
    exchange_currencies_convenient:
      '通过直接兑换和C2C交易，货币之间的交换变得很方便!',
    offline_convenient: '即使离线也可以更方便地使用COCOBANGK的服务!',
    how_wallets_accounts_different: '钱包和账户有什么不同?',
    same_means_storing_cryptocurrency:
      '虽然在ONETETHER中钱包和账户是存储加密货币的相同方法，但是根据加密货币交易的类型（内外部）的不同，，其使用方式也不同。也就是说，钱包用于交易所和ONETETHER之间的交易（外部），而帐户则用于ONETETHER中的交易（内部）.',
  },
  header: {
    inquiry_history: '咨询记录',
    certification_management: '认证/管理',
    c2c_enroll: '购买/销售注册',
    wallet_list: '钱包/历史记录查询',
    wallet: '钱包',
    c2c_list: '购买/出售记录',
    no_c2c_sell_list: '没有销售记录。',
    transfer_list: '兑换记录',
    no_transfer_list: '没有兑换内容',
    withdrawal_list: '存/取款记录',
    my_info: '我的信息',
    home: '主要',
    payment_history: '帐单纪录',
    account_transfer: '转账',
    transfer_history: '转账明细',
    register_used_account: '注册经常使用的账户',
    exchange: '直接兑换',
    exchange_list: '兑换明细',
    email: '电子邮件',
    email_list: '电子邮件历史记录',
    otp: 'OTP',
    otp_list: 'OTP历史',
    register_account: '注册帐号',
    calculation_account_list: '结算清单',
    security_certification: '安全认证',
    exact_calculation: '调整',
    history: '历史',
    coco_open_market: 'COCO公开市场',
    information: '信息',
    my_profile: '我的信息',
    email_modify: '编辑电子邮件',
    password_modify: '修改密码',
    inquiry: '查询',
    one_on_one_inquiry: '1：1咨询',
    frequently_asked_questions: '常问问题',
    announcement: '通知',
    notice: '公告',
    server_notice: '服务器公告',
    service_center: '服务中心',
    profile: '会员资料',
    company: '企业',
    account_management: '账户管理',
    do_exchange: '为了交换',
    transfer: '转账',
    look_up: '查询',
    faq: '常问问题',
    server: '服务器',
    email_auth: '电子邮件认证',
    email_request: '电子邮件联系',
    Product_Subscription: '商品&加入',
    easy_payment: '轻松付款',
    easy_login: '轻松登录',
  },
  footer: {
    footer_msg: '请在ONETETHER上使用与COIN相关的账号！',
    footer_sub_msg: '请通过我们的ONETETHER使用交易，钱包和服务',
    footer_sub_msg2: '提示',
    footer_sub_msg3: 'ONETETHER支持所有环境',
    ICO: 'ICO',
    c2c: 'C2C交易所',
    b2c: 'B2C交易所',
    margin_exchange: '保证金交易所',
    gift_exchange: '期货交易所',
    Binary: '二元期权',
    open_marcket: '公开市场',
    game: '游戏',
    proceed: '正在进行的交易',
    public: '已列出',
    direct_ex: '直接兑换',
    buy: '买入',
    sell: '卖出',
    buy_sell: '买/卖',
    holding_coin: '持有硬币',
    fee: '费用信息',
    exchange: '交易所',
    transfer_record: '交易记录',
    Leverage: '杠杆',
    live_exchange: '实时交易',
    demo_exchange: '模拟交易',
    contest: '竞赛',
    powerball: '强力球',
    law:
      '法律：ONETETHER.COM 登录号码：70638826927（U 6 29 Railway Pde EastwoodNSW 2122）',
    law1:
      'Trading Point of Financial Instruments Ltd（澳大利亚）的全部所有者ONETETHER PTY Ltd登录号码：70638826927商号。',
    law2:
      '该网站由ONETETHER Corp运营。ONETETHER Corp的批准号码为64190-由Auxiliary finance service制约，参考号码为70638826927在澳大利亚登录。',
    law3: 'ONETETHER是根据澳大利亚金融商品投资方针运营的。',
    law4:
      'ref. no. 538324 | ABN reg. 70638826927 | BA reg. 64190. 在居住国家的法律规定中，确认ONETETHER服务是否允许使用是顾客的责任。',
    law5: '请阅读ONETETHER的危险公示专文。',
    law6:
      'ONETETHER不为美国、伯利兹、毛里求斯、日本、阿尔伯塔、英属哥伦比亚、魁北克、萨斯喀彻、海地、苏里南、北韩、波多黎各和塞浦路斯占领地区的居民提供服务。',
    law7: '详细内容请参考常问问题制约部分。请参考我们的风险公示',
    law8:
      '限制地区：Trading Point of Financial Instruments Ltd不向第三世界国家地区提供投资和附加服务。',
    law_warn: '风险提示：',
    law_1:
      'CFD具有高风险和复杂的产品，由于杠杆作用会有很大的风险。个人投资者69.10％中CFD交易时，都会亏钱。',
    law_2:
      '您必须考虑是否能接受和理解CFD的运行方式，拥有较高赔钱的风险。请参考我们的风险公示。',
    alert_title: '注注和',
    coco_market: 'COCOMARKET',
    ieo_market: 'IEO市场',
    news: '新闻',
    event: '活动',
    platform_rental_title: '平台出租',
    education: '教育',
    online_Academy: '线上学院',
    offline_Academy: '离线学院',
    shopping_basket: '购物车',
    best_product: '更多特价',
    order: '订购',
    my_page_title: '我的页面',
    member_info_management: '会员信息管理',
    order_management: '订单管理',
    my_question: '我的问题',
    one_enquiry: '1：1咨询',
    community: '社区',
    lotto: '乐透型彩票',
    rock_event: '剪刀石头布',
    quiz_game: '答题游戏',
    ladder_game: '梯子游戏',
    tetris: '俄罗斯方块',
    split_lotto: '分享彩票',
    day_Lottery: '一日彩票',
    attendance: '签到',
    scoop_out: '转发',
    forum: '论坛',
  },

  main_msg: {
    about_1_title: '全球最佳加密货币交易服务',
    about_1_msg: 'ONETETHER领导与硬币有关的所有服务。',
    about_1_1_msg: '您可以在世界上第一次在一个地方买卖加密货币硬币。',
    about_1_2_msg: '至于直接交换它是在ONETETHER。',
    about_2_title: '即时交换系统',
    about_2_msg:
      'ONETETHER使用稳定的多重并行匹配技术 先进的设计技术可实现即时交换 我有货币兑换系统',
    about_3_title: '创建钱包',
    about_3_msg:
      'ONETETHER由韩国最好的安全专家组成 提供最新的安全系统和WALLET系统。',
    about_4_title: '简易交易系统 （C2C）',
    about_4_msg:
      ' ONETETHER建立了一个用户友好的简易交易系统 让交易变得更容易。',
    c2c_main_msg1_1: 'ONETETHER将立即交换使用可靠的多机并联匹配技术',
    c2c_main_msg1_2: '握住交换系统，运用先进的设计技术，使和',
    c2c_main_msg1_3: '有。',
    c2c_main_msg2_1: '安全专家已经ONETETHER是由韩国最好的工程师',
    c2c_main_msg2_2: '配备了国家的最先进的安全系统提供电子钱包系统。',
    c2c_main_msg3_1: 'ONETETHER更容易建立人性化的交易系统',
    c2c_main_msg3_2: '它可以很容易地交易。',
  },
  toasted_msg: {
    agree_required_term: '请同意所需的条款和条件',
    must_read_term: '请阅读或下载全部条款。',
    confirm: '已确认',
    changed: '更改',
    withdrawal: '已停用',
    register: '已注册',
    delete: '它已被删除。',
    title: '通知',
    exchange: '直接货币已成功处理。',
    search: '已查看',
    deposit_request: '您的存款请求',
    withdraw_request: '要求提款',
    create_account: '以开户',
    modify: '修改',
    cancel: '取消',
    trade_confirm: '交易已确认。',
    trade_reject: '交易被拒绝。',
    copy: '已复制',
    nice_msg: '如果您的浏览器设置不允许弹出窗口，则身份验证将无法正常进行。',
    nice_title: '指南',
    nice_success: '您的认证成功。',
    nice_error: '我无法验证自己的身份。',
    no_transfer: '没有交换信息',
    email_auth: '电子邮件验证成功完成',
    email_auth_send: '验证电子邮件已发送',
    kyc_withdraw: '帐户验证成功',
    not_allow_trade: '交易无效',
    id_find_mail_send: '您的电子邮件已发送。',
    duplicate_check: '重复的ID或邮件。',
    pay: '付款完毕。',
  },
  private: {
    deal_list: '销售历史',
    app_list: '购买历史',
    deal_buy_asset: '要购买的资产',
    buy_price: '购买价格',
    confirmed_source_amount: '已确认的销售数量',
    holding_source_amount: '未承诺的销售数量',
    potential_source_amount: '可用数量',
    direct_market: '直接兑换',
    deal_enroll: '销售注册',
    app_enroll: '购买注册',
    select_market: '市场选择',
    fee_rate: '手续费率',
    deal_info_input: '输入销售信息',
    deal_source_amount: '销售数量',
    deal_price: '每件售价',
    deal_enroll_account: '待售帐户注册',
    account_select: '选择帐户',
    direct_asset_select: '请选择要出售和购买的资产',
    please_select_asset: '请选择资产',
    basic_rate: '目前行情',
    direct_transfer_buy: '立即购买',
    direct_transfer_sell: '立即出售',
    direct_source_amount: '兑换数量',
    direct_target_amount: '应用数量',
    direct_asset_buy: '用{0}进行购买',
    direct_asset_sell: '作为{0}出售',
    selected_deal_info: '选定的销售信息',
    deal_source_asset_title: '购买资产',
    deal_total_source_amount: '总销售数量',
    app_info_input: '输入购买信息',
    app_amount: '购买数量',
    app_deal_price: '每单位价格',
    pay_target_amount: '付款数量',
    fee: '费用',
    fee_calc: '费用金额',
    msg_fee_calc: '减去{0}',
    app_account: '购买注册帐户',
    app_receive_account: '选择要接收的帐户',
    c2c_buy_select_asset: '请选择要购买的资产',
    go_home: '返回主目录',
    buy_calc_spread: '购买汇率',
    sell_calc_spread: '出售汇率',
    cs_market_asset: '资产对',
    cs_market_basic_rate: '买卖基准率',
    transfer_type: '兑换类型',
    exchange_rate: '适用汇率',
    submit_transfer: '立即兑换',
    deal_source_min_amount: '最小购买量',
    closed_date: '终结日',
    no_deal: '无销售清单',
    app_price_per_quantity: '每单位价格',
    app_fee_amount: '总计',
    select_deal_app_list: '购买选定的商品',
    no_select_deal_app_list: '此交易没有购买记录',
    transfer_source_amount: '基准资产数量',
    transfer_target_amount: '相对资产数量',
    transfer_basic_rate: '适用买卖基准率',
    transfer_spread_rate: '应用点差率',
    transfer_exchange_rate: '应用汇率',
    transfer_list_detail: '兑换申请详细信息',
    transfer_source_asset: '基准资产',
    transfer_target_asset: '相对资产',
    transfer_source_account_number: '基础资产帐号',
    transfer_target_account_number: '相对资产帐号',
    transfer_detail_type: '交换类型',
    transfer_regdate: '申请日期',
    transfer_asset_info: '{0}至{1} {2}',
    transfer_asset_select: '请选择要更换的资产',
    msg_transfer_buy: '用{0}进行购买',
    msg_transfer_sell: '以{0}出售',
    deal_fee_amount: '售披露方收取的费用',
  },
  wallet_page: {
    have_asset: '持有资产',
    asset_list: '资产列表',
    account_list: '帐户列表',
    account_create: '创建帐户',
    deposit: '存款',
    withdraw: '取款',
    deposit_list_look: '存款记录查询',
    deposit_look: '存款查询',
    withdraw_list_look: '取款记录查询',
    withdraw_look: '提款查询',
    account_modify: '编辑帐户',
    deposit_apply: '申请存款',
    withdraw_apply: '取款',
    deposit_request_amount: '存款金额',
    withdraw_request_amount: '取款金额',
    withdraw_account_info: '取款账户信息',
    holder_name: '储户名',
    bank_name: '银行',
    withdraw_bank_address: '帐号',
    withdraw_address: '资产地址',
    qr_address: '钱包地址',
    create_qr_address: '开设帐户地址',
    account_enroll: '登录账户',
    account_seq: '账户专号',
    account_title: '帐户名',
    regdate: '开户日期',
    before_regdate: '(开户前)',
    holding_balance: '冻结金额',
    select_asset: '选择资产',
    create: '开户',
    deposit_list: '存款记录',
    no_deposit_list: '没有存款申请的详细信息。',
    deposit_apply_detail: '存款申请详细信息',
    asset_title: '资产名称',
    request_amount: '请求金额',
    withdraw_list: '取款记录',
    no_withdraw_list: '没有提款要求。',
    withdraw_apply_detail: '取款申请详细信息',
    withdraw_fee_total_amount: '总取款额（包含手续费）',
    net_amount: '最终金额',
    fee_type: '手续费类型',
    fee_charge_type: '手续费附加类型',
    amount_of_fee: '手续费附加额',
    create_account_address: '开户地址',
    deposit_msg: '从钱包外面存入我的钱包{0} {0}。',
    deposit_msg_1: '一旦被批准350倍（确认）的嵌段链{0}的交易将反映在钱包。',
    deposit_step_1: '步骤1首先检查ID {0}备忘录。',
    deposit_step_1_1: '我的笔记ID {0}',
    deposit_step_1_2:
      '{0}当你的存款必须标记你自己的笔记ID。 {0}，没有转印笔记ID丢失。',
    deposit_step_1_3: '查看您的{0}钱包地址。',
    deposit_step_1_btn: '注身份证复印',
    deposit_step_2: '第2步：检查你的钱包地址。',
    deposit_step_2_1: 'QR码',
    deposit_step_2_2: '钱包地址',
    deposit_step_2_3:
      '最低存款量的<span style = “颜色：＃4a90e2”> {0} {1} </跨度>。',
    deposit_step_2_btn: '钱包复制地址',
    deposit_msg_2: '请检查',
    deposit_msg_2_1: '这个地址都是只存。',
    deposit_msg_2_2:
      '它需要以符合完成的总时间可通过块链网络的拥塞的影响，cryptocurrency星块链接拥塞的<span style ="color: #4a90e2; cursor: pointer;">此处</span>你可以检查。',
    no_account_list: '没有帐户列表。',
    no_favorite_account_list: '没有收藏夹帐户列表。',
    input_account: '请输入要变更的账户名',
  },
  my_page: {
    my_profile: '我的信息',
    user_unique_num: '会员专号',
    user_name: '用户名',
    email_address: '电子邮件',
    register_regdate: '注册日期',
    last_login: '上次登录',
    auth_complete: '身份验证完成',
    not_auth: '未认证',
    expdate: '到期日',
    act_auth: '认证',
    realname_auth: '人员身份验证',
    email_auth: '电子邮件认证',
    otp_auth: 'OTP 认证',
    enroll: '登录',
    security: '安全等级',
    show_security: '查看安全等级',
    auth_withdraw_address: '取款地址验证',
    apply_list: '申请记录',
    password_modify: '修改密码',
    email_modify: '修改电子邮件',
    account_block: '注销账户',
    placeholder_old_password: '请输入密码',
    placeholder_new_password: '请输入新密码',
    placeholder_confirm: '请再输入一次',
    placeholder_password: '请输入密码',
    placeholder_email: '请输入新的电子邮件',
    mail_cert_list: '电子邮件应用历史',
    no_mail_list: '没有电子邮件应用历史。',
    nominee_detail: '被推荐者记录',
  },
  kyc: {
    register_account: '注册帐号',
    kyc_enroll: 'KYC 认证',
    kyc_enroll_2: 'KYC 地址证明',
    kyc_enroll_3: 'KYC 4步向上调整的原因',
    auth: '认证',
    auth_code_send: '发送验证码',
    auth_code: '验证码',
    msg_auth_code: '请在5分钟内输入您的验证码',
    type_title: '类型名称',
    withdraw_auth: '验证取款地址',
    withdraw_auth_tit:
      '这是为了取款而进行的取款地址认验证。请登记取款账户及钱包地址。',
    select_asset: '选择资产',
    select_bank: '选择银行',
    holder_name: '持有人的姓名',
    birth: '出生的6位数字',
    address: '资产地址',
    withdraw_list: '取款账户申请记录',
    bank_name: '银行名称',
    withdraw_info: '提款账户信息',
    withdraw_complete: '资产已被验证。',
    regdate: '登录日',
    delete_withdraw_address: '取款地址变更',
    delete_success_address: '撤出地址已更改。',
    kyc_cert_list: 'KYC 认证记录',
    no_kyc_list: '没有KYC申请历史。',
    no_kyc_withdraw_address_list: '没有支付账户的应用历史。',
    kyc_placeholder: '请输入。',
  },
  otp: {
    enter_verification_number: '输入您的OTP验证码',
    otp_auth: 'OTP认证',
    authenticode: 'OTP密钥',
    otp_deactivate: '停用OTP',
    msg_authenticator_installation:
      '请在智能手机或台式机上安装“ Google Authenticator”应用',
    android: 'android ',
    or: '或 ',
    iphone_series: 'iPhone，iPad和iPod',
    windows_phone: ' Windows Phone',
    and: ', 和',
    msg_microsoft_other_systems: '“其他系统，包括Microsoft Windows桌面”',
    msg_key: '此密钥',
    msg_use_loss_change: ' 写在纸上当您丢失设备或需要更改OTP时使用。',
    msg_brcode_touch:
      '运行“ Google Authenticator”应用，然后点击屏幕底部的<b>扫描QR条形码</b>。',
    msg_input_authenticode:
      '请在下面的“授权代码”字段中输入显示在设备屏幕上的验证码。',
    otp_key: 'OTP密钥',
    otp_activate: 'OTP激活',
    otp_copy: '已复制OTP密钥',
    otp_safe_keeping: '您是否将OTP密钥写在纸上并将其存储在安全的地方？',
    yes: '是',
    otp_register: '注册',
    otp_register_success: 'OTP注册成功完成',
    otp_delete_success: 'OTP擦除注册成功完成。',
    msg_click_key_copy: '单击以复制密钥',
    otp_login: 'OTP登录',
  },
  security: {
    show_security: '显示安全级别',
    grade: '等级',
    condition: '条件',
    restriction: '限制',
    no_grade: '未分级',
    no: '无',
    security_title: '受安全条件的约束',
    banner1: '可靠的安全性',
    banner2:
      '对于通过ONETETHER购买或出售，ONETETHER必须通过安全的结算和付款方案对接收ONETETHER安全数据加密，实时交易监控，买方和卖方保护政策，以及所有的付款。',
    banner_invite: 'ONETETHER还没有账号？',
    banner_join: '免费会员注册',
    banner3: '如何ONETETHER是保持我们的客户的安全',
    content1_h3: '买家保护',
    content1_text:
      '如果买方ohbaesong磨损或损坏mibaesong，ONETETHER可以弥补总付款金额，包括运费为符合条件的交易成本。*',
    content2_h3: '卖家保护',
    content2_text:
      '如果你收到一个未经授权的付款或mibaesong要求对卖方在销售符合条件，就可以得到全额保护。*',
    content3_h3: '数据加密',
    content3_text:
      '以帮助TLS，HTTPS连接保持支付，关键钉扎移动应用的，符合PCI标准更安全。',
    content3_btn: 'PCI法规遵从',
    content4_h3: '防欺诈',
    content4_text:
      '所有的交易都是通过分析您的帐户和支持，以防止欺诈行为和结算实时监控。',
    sec_h2: '检查购买',
    sec_text:
      'ONETETHER因为监控每天24小时，一年365天，当它检测到来自平常不同的东西联系买家交易要求您确认您的登录或购买。此外ONETETHER检查通过e-mail所有的采购和销售。',
    wran_h2: '如果你发现一个可疑点',
    warn_step1: '报告。',
    warn_step1_text1: '确认之后的细节还没有找到一个交易批准',
    warn_step1_text2: '报告问题>未经授权的活动报告',
    warn_step1_text3: '点击或立即联系ONETETHER。',
    warn_step2: '检查是否有其他问题。',
    warn_step2_text1:
      '查看近期交易活动和帐户设置，以确保该额外费用或变更，也请将此信息报告。',
    warn_step3: '请更改您的密码。',
    warn_step3_text1:
      '你可以在安全菜单上的帐户设置。或者，如果您无法在您的帐户登录',
    warn_step3_text2: '登录>登录问题',
    warn_step3_text3: '点击获取复位。',
    warn_btn: '报告未经授权的交易',
    online_h2: 'ONETETHER支持安全的网上活动。',
    online_h3: '帐户安全',
    online_text: '具有高度安全的密码保护您的帐户。',
    online_btn: '了解更多',
    auth_incomplete: '认证不完整',
  },
  input: {
    id: '请输入ID',
    password: '请输入密码（8 ~ 32位包含特殊字符）',
    repeat_password: '请重新输入密码',
    user_name: '请输入用户名',
    email_address: '输入E-mail地址',
  },
  oauth: {
    contact_msg: '想要访问应用程序中的{0}的以下信息。',
    agree_msg: '{0}你是否同意访问{1}的个人信息？',
    agree_info:
      '/储存一段服务的用户标识提供将被使用的信息，统计，帐户链接的CS等。基本信息并提供所需的项目是必须提供使用ONETETHER服务的信息。',
    agree_request: '供品',
    agree_msg2:
      '一旦同意，这些信息将按照条款和条件以及服务的隐私政策进行管理。',
    agree: '同意',
  },
  pay_head_foot: {
    account_management: '账户管理',
    settlement_account_list: '结算账户清单',
    account_summary_views: '簡要账户查询',
    fund: '资金',
    history: '帐单纪录',
    help: '帮助',
    qa: '咨询',
    fee: '佣金',
    secure: '安全',
    go_shop: '购物',
    my_info: '我的个人资料',
    my_page: '帐户设置',
    out: '退出',
    in: '登录',
    about: '公司介绍',
    blog: '博客',
    employ: '乔布斯',
    site_map: '网站地图',
    developer: '开发人员',
    partner: '伙伴',
    privacy_state: '个人信息处理方针',
    usage: '使用条款',
    feed_back: '反馈',
    warn_to_consumer:
      '通知客户：支付ONETETHERⓒONETETHER的预付费方式的业主不需要澳大利亚金融监管局的批准。请仔细阅读条款和条件。',
  },
  continue: '延续',
  pay_home: {
    cocobank_title: 'ONETETHER',
    platform: '平台',
    platform_rental: '租赁平台',
    cocopay_is: 'ONETETHER是业务的增长',
    help: '帮助。',
    home_banner_1: '扩大潜在客户群遍及世界各地，并促进支付管理，',
    home_banner_2: '经营的卖家保护*，并允许安全与全天候防欺诈监控到店。',
    home_banner_3: '你可以更容易获得成功。',
    home_banner_warn: '*条款和条件适用于保护卖家。请参阅您的合同上的资格详情。',
    home_banner_join: '现在加入免费。',
    home_sec1_openShop: '您可以在ONETETHER开一家店。',
    home_sec1_btn: '为了应对',
    home_sec2_h2: '请选择您需要的付款方式。',
    home_sec2_text1: 'ONETETHER可以通过网上，手机还有电子邮件进行结算。',
    home_sec2_text2: '无论销售给谁，ONETETHER都会帮助您更容易更安全的结算。',
    home_sec2_online_pay: '在线支付',
    home_sec2_online_text:
      '可轻松设置ONETETHER的付款按钮，在收到结算款、定期结算、捐赠等时也非常方便。借助ONETETHER Checkout，使客户可以更轻松，更快捷地付款。',
    home_sec2_online_more: '查看更多有关网上支付',
    home_sec2_voice_invoice: '电子邮件发票',
    home_sec2_voice_text:
      '使用专业的免费发票进行简单的电子邮件付款。不仅可以用于海外顾客，也可以用于没有ONETETHER账号的顾客。',
    home_sec2_voice_more: '查看更多有关电子邮件发票',
    home_sec2_exchange_pay: '在交易所付款',
    home_sec2_exchange_text:
      '借助交易所上集成的钱包服务，您可以在合作伙伴公司的任何交易所进行充值和买卖币。',
    home_sec2_exchange_more: '了解有关交易所收费的更多信息',
    home_sec2_mobile_pay: '移动付款',
    home_sec2_mobile_text:
      '该解决方案针对移动设备进行了自动优化。可以在全世界任何地方都可以通过移动网站或Android及iOS应用程序更容易地进行结算。',
    home_sec2_mobile_more: '查看更多关于移动支付',
    home_sec3_h2: '找到ONETETHER特约合作伙伴更多的工作。',
    home_sec3_global:
      'ONETETHER将与世界顶级自由职业者的网站连接更多的全球机会。',
    home_sec3_btn: '检查自由ONETETHER',
    home_sec4_h2: '这很容易上手。',
    home_sec4_banner1: '了解你需要从ONETETHER商业中心开始一切。',
    home_sec4_banner2: '加盟商的帐户，并确认您的电子邮件地址',
    home_sec4_banner3: '认证的银行账户',
    home_sec4_banner4: '选择一个支付解决方案',
    home_sec5_h2: '为什么全世界那么多的企业家信<br/>赖ONETETHER？',
    home_sec5_sub_text:
      '因为它是一个很好的选择。 ONETETHER销售者会给全世界200多个市场的2亿名以上的顾客连接25个货币。',
    home_sec5_sub_text_1: '因为它是一个很好的选择。',
    home_sec5_sub_text_2:
      'cocobank给全世界200多个市场的2亿以上的顾客连接25个通货',
    home_sec5_h3: '安全。',
    home_sec5_h3_sub1:
      '自动辨别欺诈，24小时监控交易和买卖双方的保护程序，以保护您的业务和客户。',
    home_sec5_h3_more: '查看更多有关网上支付',
    home_sec5_h31: '全世界都在使用。',
    home_sec5_h31_sub1:
      '任何人都不需要每次输入信息，可以快速进行付款。您可以在203个市场中以26种货币通过信用卡，借记卡或ONETETHER付款。',
    home_sec5_h31_more: '查看更多有关电子邮件发票',
    home_sec5_h32: '快。',
    home_sec5_h32_sub1:
      '当客户付款时，在大多数情况下，它会立即存入ONETETHER帐户，可以随时取款到银行或付款给供应商，可以自由的在COBANK结算的地方使用。',
    home_sec5_h32_more: '查看更多有关eBay网站上出售',
    home_sec6_h2: '简单的收费结构',
    home_sec6_sub:
      'ONETETHER会收取一定的费用，只有当销售取得。 ONETETHER费用是根据客户的位置和销售金额固定。',
    home_sec6_more: '查看更多有关费用',
    home_sec7_h2: '社区为韩国销售，CBT LAB',
    home_sec7_text1:
      '跨境贸易研究所（CBT LAB）是资助海外的电子商务ONETETHER韩国（ONETETHER韩国）商人社区启用。',
    home_sec7_text2:
      'CBT LAB帮助东海岸业务增长全球共享信息，如最新趋势，提示和最佳实践。',
    home_sec7_more: '了解如何采取CBT LAB的优势',
    home_sec8_h2: '满足合作伙伴联锁ONETETHER。',
    home_sec8_text1: '需要为您的网上业务的专业帮助？',
    home_sec8_text2:
      'Web托管解决方案，购物车，电子商务解决方案，如前期工程ONETETHER合伙买了这帮助您的业务。',
    home_sec8_text3: '现在发现ONETETHER为自己的公司的合作伙伴。',
    home_sec8_more: '更多的合作伙伴',
    home_sec9_h2: '成为全球畅销书。这将一起ONETETHER。',
    home_sec9_h2_1: '成为全球畅销书。',
    home_sec9_h2_2: '这将一起ONETETHER。',
    home_sec9_btn: '立即注册一个帐户',
    home_learn_h2: '了解更多',
    home_learn_li1: '网络支付解决方案',
    home_learn_li1_1: '网站付款标准',
    home_learn_li1_2: 'ONETETHER结帐',
    home_learn_li1_3: '在eBay上购买',
    home_learn_li1_4: '比较解决方案',
    home_learn_li2: '其他应付款',
    home_learn_li2_1: 'ONETETHER电子邮件发票',
    home_learn_li2_2: '移动商务',
    home_learn_li2_3: '业务的自动付款',
    home_learn_li2_4: 'ONETETHER对于B2B',
    home_learn_li2_5: 'ONETETHER自由职业者',
    home_learn_li3: 'ONETETHER设置和集成',
    home_learn_li3_1: 'ONETETHER商业中心',
    home_learn_li3_2: 'ONETETHER韩国商人社区（CBT LAB）',
    home_learn_li3_3: '添加ONETETHER ONETETHER到现场',
    home_learn_li3_4: '检查出最好的指南套装',
    home_learn_li3_5: '开发人员',
    home_learn_li3_6: '伙伴',
    home_learn_li3_7: '如何ONETETHER',
    home_learn_li4: '管理我的帐户',
    home_learn_li4_1: 'ONETETHER商业应用',
    home_learn_li4_2: '商务帐户设置',
    home_learn_li4_3: '卖家保护计划',
    home_learn_li4_4: '管理客户投诉',
    home_learn_li4_5: '了解退款（退款）',
    home_learn_li4_6: '了解帐户限制',
    home_learn_li4_7: '诈骗防范技巧',
    home_learn_li4_8: 'PCI法规遵从',
  },
  pay_nav: {
    view_your_account: '总账户查询',
    account_summary_views: '簡要账户查询',
  },
  pay_login: {
    secure_sub_title: '登录和安全性',
    secure_my_profile: '我的个人资料',
    secure_update_complete: '环境状况和设置已经更新。',
    secrue_suggest: '每当你告诉我们你的经验。',
    search: '取回',
    my_info: '个人信息',
    update: '更新',
    e_mail: '电子邮件',
    default: '基本信息',
    call: '电话',
    phone: '（手机）',
    pay_mobile: '移动支付',
    trading: '给予和索取',
    password: '密码',
    change: '变化',
    secure_qa: '安全问题',
    staying: '记住我的登录更快采购',
    edit: '汇编',
    browse_manage: '管理所选设备和对保持登录状态的浏览器。',
    account_type: '账户类型',
    account_delete: '注销',
    business: '业务',
    edit_email: '编辑电子邮件地址',
    change_email: '更改电子邮件地址',
    update_email: '添加您的电子邮件',
    eamil_url: 'E-mail地址',
    update_email_url: '添加您的电子邮件地址',
    error_email: '抱歉。默认的电子邮件不能被编辑。',
    confirm_new_email: '检查新的电子邮件地址',
    change_mail: '更改电子邮件',
    confirm: '确认',
    changing: '变化',
    deleting: '删除',
    reaming:
      '目前有两个与您的帐户关联的电子邮件地址。您可以添加更多5电子邮件。',
    qa_1: '什么是第一次参加学校的名字？',
    qa_2: '什么是第一只宠物的名字是什么？',
    edit_phone: '编辑现有的电话号码',
    korea: '韩国',
    explanation:
      '添加了数字，我确认您同意自动拨打，接听预录电话和文本取决于原因机关将两个数字相加的隐私政策进行说明。标准费率付费。',
    edit_phone_num: '变更电话号码',
    edit_password: '更改密码',
    confirm_password: '检查您当前密码',
    new_passod: '新密码',
    confirm_password_new: '确认新密码',
    secure_question: '安全问题',
    secure_pick: '选择题',
    secure_answer: '答案',
    edit_browse:
      '随着ONETETHER一键就可以快速完成支付，而不必每次都要登录时间英寸',
    already_log: '在登录到计算机上。',
    off_all: 'ONETETHER一键关闭所有设备上的',
    support: 'PayPal致力于让客户100％满意。如果您有您的帐户有问题',
    support_center: '客户支持',
    support_text1: '或检查',
    support_text2: '请参考。',
    support_warn:
      '如果您取消帐户，则无法取消您的帐户记录也将消失和可靠性水平。',
  },
  help: {
    support_center: '支持',
    resolution_center: '争议解决中心',
    qa_search: '搜索常见问题解答',
    common_qa: '常问问题',
    common_qa_1: '什么`为什么通过“获取链接基金更新您的订单状态后显示错误消息？',
    common_qa_2: '如何从韩国ONETETHER账户中提取资金？',
    common_qa_3: '如何添加借记卡或信用卡帐户ONETETHER？',
    common_qa_4: 'ONETETHER我忘记了帐户密码。如何重置密码？',
    common_qa_5: '我能取消已经发出已支付金额ONETETHER？',
    common_qa_6: '我如何收到通过ONETETHER付款？',
    common_qa_7: '如何发送通过ONETETHER支付？',
    common_qa_8: '如何添加一个银行账户ONETETHER帐户？',
    common_qa_9: '如何检查我的帐户ONETETHER相关联的银行帐户？',
    common_qa_10: '如何禁用帐户ONETETHER限制？',
    technical_support: '订阅技术问题和更新。',
    condition_cocopay: '查看ONETETHER状态',
    muliple_help: '更多方式获得帮助',
    trading_help: '为了解决这样的问题处理',
    tex_center: '税务中心',
    tex_help: '查找税务表格和其他资源',
    need_help: '联系我们',
    help_center: '联系客户支持',
    help_to_center: '联系客户支持',
    prepare: '准备中',
    fast_help: '请告诉我们您的问题，使我们能更快地帮助ONETETHER。',
    my_search: '搜索我的问题',
    common_problem: '常见问题',
    login_problem: '登录问题',
    unkown_charge: '未经授权的访问或未知的申请报告',
    send_money: '汇款',
    get_fund: '收到钱',
    withdraw_money: '取钱',
    pay_cancel: '付款或取消订单',
    pay_hold: '付款挂起或等待',
    refund: '退款',
    pre_pament: '预先核准付款',
    negative_balance: '负平衡',
    account_qa_1:
      '虽然它显示为“已完成”从我的帐户ONETETHER退出状态，这是为什么不包含银行账户的钱？',
    account_qa_2: '什么是我的提款ONETETHER的原因仍是“待定”状态？',
    account_qa_3: '为什么我撤回前？',
    item_title: '访问密码和帐户',
    item_title_2: '帐户资料＆设置',
  },
  business: {
    no_trade: '没有可以兑换的市场',
    view_your_account: '总账户查询',
    available: '可得到',
    calculate_late: '显示最重要的CCF账户和现持有的所有资产',
    payment_transfe: '支付转账',
    exchange: '货币兑换',
    currency_update: '添加通话',
    update_btn: '加号按钮',
    currency_cal: '货币换算',
    pay_default: '首付款',
    payment_send: '发送或请求付款',
    account_list: '帐户列表',
    no_alias: '无别名',
    new_bank: '连接新银行',
    card: '卡',
    new_card: '连接新卡',
    credit: '信用',
    preference_payment: '选择您喜欢的在线支付方式。',
    payment_tip:
      '当网上购物或使用该手段商品和服务在付款。您可以在任何时候选择在结帐时不同的付款方式。',
    payment_more: '了解您的支付偏好',
    paymnet_changes: 'ONETETHER平衡',
    debit_card: '转账卡',
    currency_tip:
      '如果添加的货币，该货币以后接收的所有款项将记入相应的资金。基础货币被用来发送一个付款或付款请求。',
    currency_1: '澳大利亚元',
    currency_2: '瑞士法郎',
    currency_3: '捷克克朗',
    currency_4: '丹麦克朗',
    currency_5: '欧元',
    currency_6: '英镑',
    currency_7: '港元',
    currency_8: '福林',
    currency_9: '以色列新谢克尔',
    currency_10: '墨西哥比索',
    currency_11: '挪威挪威克朗',
    currency_12: '纽元兑美元',
    currency_13: '菲律宾比索',
    currency_14: '波兰兹罗提',
    currency_15: '俄罗斯卢布',
    currency_16: '瑞典克朗',
    currency_17: '新加坡元',
    currency_18: '铢',
    currency_19: '新台币',
    withdraw_account: '撤回账户',
    exchanged: '货币兑换后',
    exchange_rate: '汇率',
    exchange_tip: '汇率是基于当前汇率的估计量，交换费包含在ONETETHER。',
    currency_default: '（A）的日元被设置为默认货币。',
    currency_default_notice: '基础货币被用来发送一个付款或付款请求。',
    currency_default_notice2: '关闭通话的余额，不显示没有收到任何付款的电话。',
    currency_default2: 'JPY（S），默认',
    currency_quit_jp_btn: '关闭美元',
    currency_quit_btn: '千钧一发',
    bank_account: '帐号',
    bank_account_create_day: 'Gaeseolil',
    bank_account_change: '余额',
    bank_account_check: '保兑行',
    bank_account_remove: '删除银行',
    bank_continue: '你想继续吗？',
    bank_tip: '与银行待处理的交易被删除后进行处理。',
    bank_this_delete: '删除银行',
    card_tip: '该ONETETHER帐户要使用它无需花费或提款限额？',
    card_confirm: '检查卡。',
    card_type: '类型',
    expiry_date: '终结日',
    card_adress: '帐单地址',
    card_update: '卡更新',
    card_delete: '删除卡',
    card_this_delete: '删除卡',
    card_tip2:
      '此付款方法目前优选的。完成后，您可以设置不同的首选付款方式。处理是与（a）中未决的未定义删除后进行处理。',
    secure_code: '验证码',
  },
  shop: {
    shop_list: '商店列表',
    shop_create: '创建商店',
    shop_cre_date: '登录日',
    shop_title: '商店名',
    shop_id: '商店ID',
    shop_state: '状态',
    shop_work: '工作',
    shop_detail: '详细',
    shop_retouch: '修改',
    shop_settlement: '结算账户列表',
    shop_history: '交易记录',
    no_shop_list: '没有店铺一览',
  },
  merchant: {
    create: '登录商店',
    update: '登录',
    retouch: '商店名修改',
  },
  pay_legal: {
    service_usage: 'ONETETHER服务条款',
    detail_usage:
      '这些条款和条件将适用于亚太地区，拉丁美洲和欧洲的一些国家，中东和非洲用户。要查看条款和不同国家或地区的条件下，从下面的列表中进行选择。',
    nation: '选择一个国家',
    every_consumer: '所有用户',
    service_agree: '您的服务合同ONETETHER',
    privacy_state: '隐私政策',
    purpose_policy: 'ONETETHER使用政策',
    payment_agreement: 'ONETETHER其他方式付款协议',
    sell_buy: '商家和企业',
    shop_policy: 'ONETETHER支持存储策略',
    contract_profit: '合同以营利为目的的公司',
    billing_agreement: '结算协议',
    direct_debit_agreement: '收到ONETETHER资金和借记协议',
    additional_info: '更多信息',
    infringement: 'Somyeongseo违反政策',
    policy_update: '政策更新',
    warn1:
      '通知消费者：ONETETHER支付服务被看作是按照澳大利亚法律支付（储值工具）的预付费方式。',
    warn2:
      'ONETETHER支付的预付方式的业主ⓒCocofx私人有限公司不需要澳大利亚金融监管局的批准。我们也鼓励消费者（用户）仔细阅读这些条款和条件。',
    warn3: '本使用条款和通告的规定的条款和与特定ONETETHER服务相关的条件。',
  },
  pay_privacy: {
    effective_day: '生效日期：2019 3月28日',
    summary: '摘要',
    personal_data: '通过ONETETHER收集的个人数据',
    personal_date_cause: '理由保持您的个人资料ONETETHER',
    summary_1: '我们的用户',
    summary_2: '网站',
    summary_3: '或访问',
    summary_4: '服务',
    summary_5: '当使用用户',
    summary_6: '个人资料',
    summary_7:
      '如何收集和存储，管理和共享，解释传输已经编写了本隐私政策。访问我们的网站或使用该服务时，该隐私政策适用于您的个人资料，其他ONETETHER',
    summary_8: '用户',
    summary_9:
      '它并不适用于网站或不拥有在线web ONETETHER或调整，包括服务站点或服务。',
    summary2_1:
      'ONETETHER您可以访问我们的网站或当您使用以下类型的服务收集个人信息。',
    summary2_2: '使用向上和信息',
    summary2_3:
      '当您注册一个帐号使用ONETETHER的服务，以满足必要的信息，以提供用户所请求的服务来收集个人数据。',
    summary2_4:
      '根据所选择的服务，您可以要求提供创建用户名所需的标识信息，邮寄地址，电话号码，电子邮件地址，帐号。',
    summary2_5: '条款你可能会问，以提供额外的个人资料，这取决于服务。',
    summary3_1: '交易经验和信息',
    summary3_2:
      '使用ONETETHER，或者如果访问该网站，例如服务，从卖方购买，或收到钱，或者如果处理支付或汇款给朋友和家人，收集其他交易相关的信息，以及来自ONETETHER交易信息的。其他与贸易相关的信息，包括发送或请求金钱，物品或金钱支付服务的卖家，包括有关的所有信息来完成交易的信息和设备信息的支付方式，技术数据，位置信息等。',
    summary4_1: '参与者信息',
    summary4_2:
      '当您使用或访问网站ONETETHER服务收集的个人数据用户提供有关参与交易的其他参与者。',
    summary4_3: '要发送或请求的钱',
    summary4_4:
      '如果您发送或请求资金通过服务ONETETHER收集您的姓名，邮寄地址，电话号码，个人数据，如从参与者发送的钱给你的你的财务账户信息收钱。',
    summary4_5:
      '有关要求参与者的个人数据的范围可能取决于用于发送或要求金钱服务。',
    summary5_1: '付款方式为其他人而不是票据或票据要求付款给其他人',
    summary5_2:
      '如果使用ONETETHER服务，让他们付账代他人的，或者代表他们支付账单给其他用户，用户名，邮件地址，电话号码，电子邮件地址，用户计费，而不是账单或他人的帐户拥有者必须收集相关的个人资料，包括你想，而不是支付账号。',
    summary6_1: '钱添加到您的帐户',
    summary6_1_1: '您的帐户',
    summary6_2:
      '为了加钱到其他帐户的用户帐户或用户可以拥有，或者如果您使用ONETETHER服务请求被加入到量在此帐户对其他用户的另一边从用户有效地处理您的请求收集信息或可以从对方收集您的信息。',
    summary6_3:
      '例如，充电或使用服务ONETETHER请求，以添加到帐户的手机数量，你可以收集其他信息，包括个人资料，以及其他参与者的移动账户号码。',
    summary7_1: '与您的朋友和联系人人信息',
    summary7_2:
      '当用户在您的帐户连接的联系人列表，很容易给帮助人们处理当您的朋友和联系人ONETETHER。这样用户可以使用该设备，或者建立社会媒体平台或设备ONETETHER账户或社交媒体之间的连接时连接到该平台更好ONETETHER服务收集和ONETETHER使用您的联系人列表中的信息（姓名，地址，电子邮件地址等）改善环境。',
    summary8_1: '您选择的信息，以提供ONETETHER才能使用某些在线服务或额外服务',
    summary8_2:
      '如果请求或参加现场要求的功能或改进服务，或其他可选功能的选择，你可以收集有关ONETETHER用户的其他信息。',
    summary8_3:
      '如果从这些服务中用来收集信息的方法，由本隐私权政策声明不同，另行通知期间收集的信息。',
    summary9_1: '使用“ONETETHER不付款”的服务，当用户信息',
    summary9_2:
      '对于一些有限的服务，可能需要登录或使用您的帐户设置不付款。 ONETETHER将收集，所有的支付方式相关的设备信息，技术数据，位置信息需要用户完成交易的个人资料。当您选择帐户所有者和非贸易支付，你可以建立并与您的帐户关联收集交易信息。',
    summary9_3:
      '如果用户在不帐户拥有者，并选择非ONETETHER交易付款，收集和存储您提供的所有信息的使用和依照本隐私政策的信息共享。',
    summary10_1: '从第三方获得用户的具体信息',
    summary10_2:
      '从第三方（如商家），数据提供者，征信机构允许的范围内通过法律，你可以得到的信息。',
  },
  partner: {
    be_partner: '成为ONETETHER的合作伙伴。',
    banner_text:
      '购物平台提供商，市场，还有一个计费支持运营商需要支付服务提供商可以ONETETHER的合作伙伴。',
    banner_btn: '要联系您的客户经理',
    benefit: '合作伙伴有权ONETETHER好处',
    benefit_1: '整合与建设解决方案技术支持',
    benefit_2:
      '请随时联系我们的支持团队为您获得ONETETHER集成的帮助。 ONETETHER开发者门户还可以用来作为一种资源。',
    benefit_3: '通过营销机会的业务增长',
    benefit_4: '以提供ONETETHER可以吸引潜在客户的许多市场机会。',
    traction: '和牵引世界各地的付款。',
    traction1:
      'ONETETHER合作伙伴支持的创新平台，为顺利解决卖家的信任ONETETHER。',
    traction_btn: '更多的合作伙伴',
    program: 'ONETETHER合作伙伴计划是免费加入。',
    program_1: '请填写在线表格，我们将在ONETETHER与您联系。',
    program_2: '请介绍业务和运行的业务解决方案。',
    program_3: '请联系ONETETHER讨论必要的修改。',
    program_4: 'ONETETHER整合与和帮助确保他们收到付款ONETETHER。',
    program_btn: '要联系您的客户经理',
    common_qa: '常问问题',
    common_qa1: '是否有任何厂商ONETETHER合作伙伴？',
    common_qa1_text:
      'ONETETHER合作伙伴是B2B（企业对企业）公司，为客户提供解决方案ONETETHER。 ONETETHER正与组织，如购物车，网络托管公司，Web开发人员，物流提供商和数字营销公司，支付网关。',
    common_qa2: '什么ONETETHER合作伙伴资格？',
    common_qa2_text: '请联系您的客户经理',
    common_qa2_text_2: '您可以对合作伙伴的资格获得建议。',
    common_qa3: '我们提供的ONETETHER集成支持服务？',
    common_qa3_text:
      '一旦合作伙伴计划和ONETETHER批准加入注册，您可以访问有价值的集成文档和开发者论坛。它也可以让顾问证书集成支持。',
    common_qa4:
      '还有韩国的公司之外，我可以单独报名参加合作伙伴计划的每一个国家？',
    common_qa4_text:
      '这取决于您所在的国家经营业务。在ONETETHER正在部署专门的合作伙伴代表，在不同国家地区的要求。',
    common_qa4_more: '查看合作伙伴计划提供国家',
  },
  pay_main: {
    total_product: '总产品',
    total_sum: '骨料',
    pay_this_account: '设置此帐户作为付款方式。',
    bill_show: '所述交易信息如说明书中显示如下。',
    banner_text: 'ONETETHER更安全',
    banner_text2: '快速付款。',
    banner_text3: '无论在哪里购物，将让您的金融信息安全。',
    footer_1: '条款和条件',
    footer_2: '用户协议',
    footer_3: '隐私政策',
    footer_4: '反馈',
    footer_5:
      '通知客户：支付ONETETHERⓒONETETHER的预付费方式的业主不需要澳大利亚金融监管局的批准。',
    footer_6: '使用条款',
    footer_7: '我们也鼓励您仔细阅读。',
    footer_8: '开票',
    wallet: '电子钱包管理',
    last_name: '性别',
    card_number: '卡号',
    three_number: '三位数字',
    name: '名',
    pay_cocopay: '通过ONETETHER支付',
    free_shipping: '如果ONETETHER帐户，你可以得到免费的退货运费，购买保护。',
    email_phone: '电子邮件或电话号码',
    login_error: '你有麻烦了签约？',
    pay_card: '付款卡',
    cancel_back: '取消并返回到前一页',
  },
  site_map: {
    site_map_tip: '一个链接，这将帮助你探索ONETETHER帐户。',
    map_fund: '资金',
    map_fund_1: '扣除',
    map_fund_2: '我使用的平衡能力是什么？',
    map_fund_3: '汇款或要求付款',
    map_fund_4: '呼叫管理',
    map_fund_5: 'ONETETHER我的借记卡折扣',
    map_fund_6: '获取ONETETHER借记卡',
    map_fund_7: 'ONETETHER信贷结算时间表',
    map_deal: '交易',
    map_deal_1: '查看所有优惠活动',
    map_deal_2: '活动的意见（包括资产和费用）',
    map_deal_3: '查看特价图形和图表',
    map_deal_4: '下载新政',
    map_deal_5: '响应于根据权利要求或拒付',
    map_deal_6: 'IPN（即时付款通知）历史',
    map_profile: '我的个人资料和设置',
    map_profile_1: '商业镜',
    map_profile_2: '电子邮件，地址，电话或密码更新',
    map_profile_3: '银行账户或卡更新',
    map_profile_4: '更新通知',
    map_profile_5: '查看账户限额',
    map_profile_6: '用户管理',
    map_profile_7: '送更新偏好',
    map_support: '支持',
    map_support_1: '转至解决冲突中心',
    map_support_2: '去支持中心',
    map_support_3: '联系我们',
    map_support_4: 'ONETETHER商户费用信息',
    map_report: '报告',
    map_report_1: '报告设置，管理或下载',
    map_manage: '工具',
    map_manage_1: '查看工具',
    map_manage_2: 'ONETETHER按钮管理',
    map_manage_3: '定期支付管理',
    map_consum: '顾客',
    map_consum_1: '查看嘉宾名单',
  },
  fee: {
    fee_tip: '简单的收费结构',
    fee_banner_1: '一般来说，购买是免费的，可能受到货币兑换费。',
    fee_banner_2:
      '如果销售不坚持使用ONETETHER月租费，或者取消费用。每个委托后才会支付。',
    fee_h2: '通常购买的是免费的。',
    fee_text1: '用于处理支付费用是由卖方支付。',
    fee_text2: '但是，您可以兑换手续费应用。',
    fee_more: '卖家收费了解更多',
    fee_text3: '对于凭发票或付款电子邮件网站销售（国际支付标准费率适用）',
    fee_text4: '根据收到呼叫的固定费用',
    fee_text5: '交易所费用可以另外申请。',
    fee_text6: '例如，对于一个固定费用付款收据以美元为$ 0.30美元。',
  },
  dash: {
    more: '查看更多',
    withdraw_asset: '基金撤离',
    currency: '货币',
    quotes: '发票和会计估计',
    last_6_months: '最近6个月',
    make_invoice: '发票代',
    manage_invoice: '发票管理',
    grown_up: '请把发展业务的报价。',
    un_paid_invocie: '未付发票',
    make_quotes: '报价代',
    quotes_1: '人提出任何未付发票。',
    quotes_2: 'ONETETHER发票',
    quotes_alarm: '发送提醒',
    quotes_detail: '显示更多',
    quotes_who: '比尔：财，所以 - 杨',
    latest_act: '近期活动',
    act: '活动',
    received: '收到付款',
    send: '从付款方式',
    act_record: '活动（包括资产和费用）',
    pay_person: '付款人',
    show_all: '查看所有',
    tell_us: '请告诉我们你的意见。',
    feed_text:
      '请花一点时间来告诉我们在这个页面上全新设计的显示信息，你的意见。谢谢！',
    service: '提供反馈',
    feed_text_back: '谢谢您的意见！这是我们的网站是如何有用吗？',
    feed_placeholder:
      '请让我知道我今天来有ONETETHER是一个更好的办法的原因。不包括个人信息，如电子邮件或账户号码。',
    feed_p:
      'ONETETHER办公室工作人员和客人您的意见可以在内部发布，所以你可以看到它，不会留下任何个人信息。客户服务问题，请点击此处。 ONETETHER的',
    feed_protect: '隐私政策',
    feed_law: '法律条款',
    feed_or: '和',
    feed_need: '见',
    trade_name: '交易名称',
    trade_id: '交易ID',
    transaction_type: '交易类型',
    trade_amount: '付款金额',
    detail_show: '看',
  },
  shop_detail: {
    detail_info: '商店详细信息',
    api_signature: '商店签名密钥',
    msg_shop_create: '这家商店已被注册。',
    msg_shop_modify: '已修改',
  },
  merchant_account: {
    create_account: '生成结算账户',
    enroll_account: '登录结算账户',
    pls_select_account: '请选择结算账户',
  },
  transaction_detail: {
    transaction_title: '交易细节',
    order_id: '车间定单号',
    pay_account_title: '付款账户名称',
    pay_account_number: '支付账号',
    pay_account_balance: '付款账户余额',
    pay_account_selection: '选择支付账户',
    pay_account_selection_msg: '請選擇一個付款帳戶。',
  },
  guide: {
    guide_title_1: 'Coco Bank账户',
    guide_title_2: 'Coco银行如何转移和汇款？',
    guide_title_3: '通过Coco Bank的账户利用更方便和安全的服务。',
    guide_strapline_1: '①可以立即删除的账户',
    guide_strapline_2: '②轻松打开快速账户简单',
    guide_strapline_3: '随员',
    guide_strapline_4: '汇款',
    guide_strapline_5: '可存入韩国最多的硬币的账户',
    guide_strapline_6: '安全账户免受黑客攻击',
    guide_strapline_7: '视觉历史查询和收据可用',
    guide_strapline_8: '可用作公司结算账户',
    guide_strapline_9: '通过账户快速交易C2C和B2C交易',
    guide_strapline_msg_1: 'COCO银行的账户转移不会用于转移金钱。',
    guide_strapline_msg_3: 'Coco Bank的帐户开放是10秒。',
    guide_strapline_msg_4: '省略复杂的过程。',
    guide_strapline_msg_5: '您只能为该资产创建帐户名称。',
    guide_strapline_msg_6: '通过钱包转移',
    guide_strapline_msg_7: '使用钱包地址',
    guide_strapline_msg_8: '费用费用',
    guide_strapline_msg_9: '在Coco Bank汇款',
    guide_strapline_msg_10: '使用帐号',
    guide_strapline_msg_11: '费零',
    guide_strapline_msg_12:
      '在全球范围内发布了许多类型的加密累积。 Coco Bank正在处理各种加密累积，以帮助客户便利地根据这些变化。',
    guide_strapline_msg_13:
      '安全是加密包含的核心。 Coco Bank认为最重要的安全性，并且数码工程师在每个领域拥有超过五年的经验已经建立了安全系统。',
    guide_strapline_msg_14:
      '您可以查询帐户之间的传输。 Coco Bank的账户可以检查银行或其他银行之间的银行，如市场银行。如有必要，您可以访问该点并检查并输出发布历史记 录。',
    guide_strapline_msg_15:
      'Coco Bank的账户与Coco Market的付款和结算账户相关联。在将目标加密账户作为结算账户注册后，您可以将在Coco Market销售的货物结算到仮想通貨。',
    guide_strapline_msg_16:
      '通过钱包在个人之间的交易上发生费用和延误。 Coco Bank提供Coco Bank Consock汇款作为解决此问题的方法。通过Coco Bank的账户经历C2C和B2C交易 而无需费用和延迟。 ',
  },
  account_transfer: {
    transfer: '转账',
    transfer_list: '转账记录',
    transfer_list_title: 'ONETETHER 转账',
    transfer_list_wallet: '其他钱包转账',
    msg_required_data: '请输入所有值',
    msg_not_select_withdraw_account: '请选择付款账户',
    create_transfer_title: '转账',
    from_account_select: '选择支付账户',
    available_transfer: '转让金额',
    to_account_input: '输入转账账号',
    to_account_confirm: '转账账户确认',
    to_account_user_name: '转账会员名',
    transfer_amount: '转账金额',
    delete_amount: '更正',
    all_amount: '全额',
    description: '说明',
    transfer_btn: '转账',
    transfer_info_check: '支票转账请求信息',
    from_account_number: '取款账号',
    from_asset_title: '取款资产帐户',
    to_account_number: '转账账号',
    success_transfer: '转让已成功处理。',
    transfer_list_detail: '转账记录查询',
    search_transfer_asset: '按资产搜索',
    search_transfer_account: '按帐户搜索',
    reset: '初始化',
    search: '取回',
    transfer_list_detail_tit: '详细转账记录',
    no_transfer: '不得转让细节',
    msg_not_search_account: '是不存在的账号或无效的输入值',
    my_account_transfer: '我的账户转账',
    msg_pls_select_account: '选择资产后，搜索帐户。',
    placeholder_amount: '请输入转账金额',
    not_search_user_name: '不知道用户名',
    msg_select_asset_search: '请选择一个帐号',
    success_fail: '传送失败。',
    pls_search_asset: '请搜索资产',
    pls_search_account: '请搜索账户',
    pls_select_asset: '请选择一种资产。',
    not_exist_account: '资产的帐户不存在。',
    no_inquiry_history: '没有查询明细',
    account_number_list_1: '无法查询6个月前的转账记录。',
    account_number_list_2: '一次最多可查询期间为6个月。',
    account_number_list_3:
      '现转账结果查询的网站是查询ONETETHER内及加盟店转账结果。<br />想通过其他钱包查询转账结果的人，请在上端确认[其他钱包转账]。',
    account_number_list_3_1:
      '现转账结果查询的网站是查询ONETETHER内及加盟店转账结果。<br />想通过其他钱包查询转账结果的人，请在上端确认[其他钱包转账]。',
    today: '当日',
    one_week: '1周',
    one_month: '1个月',
    three_months: '3个月',
    six_months: '6个月',
    withdrawal_account_number: '取款账号',
    recent_order: '按最新顺序',
    past_order: '按过去顺序',
  },
  bank_service_center: {
    title: '题目',
    date: '登录日',
    state: '状态',
    enter_search_word: '输入您的搜索字词',
    list: '名单',
  },
  service_center: {
    view_all: '查看全部',
    contact_history: '咨询记录',
    privacy_Statement: '个人信息处理方针',
    would_you_agree: '您要同意以上内容吗？',
    mobile_number: '手机号码',
    target_of_inquiry: '询问对象',
    inquiry_contents: '咨询内容',
    please_enter_your_inquiry: '请输入您的询问。',
    send: '发送',
    normal_inquiries_received: '您的询问已成功收到。',
    inquiry_history: '查询历史',
    pls_select_inquiry_type: '请选择咨询的类型',
    pls_login_to_use_inquiry: '1，登录第一查询。',
    non_member_login: '非会员登录',
    contact_id: '联系ID',
    view_inquiry: '查看联系人',
    service_center: '客户服务',
    inquiry_details: '咨询历史',
    msg_enter_title: '请输入标题。',
    msg_enter_your_content: '请输入您的信息。',
    msg_pls_login: '请登录。',
    go_back: '返回',
    re_contact: '触点材料',
    contents: '内容',
    msg_no_inquiry_history: '没有联系方式。',
    msg_require_login_additional_authentication: '您需要登录或其他身份验证。',
    when_you_member: '当一个成员',
    msg_inquiry_history_can_view_after_login:
      '的联系人详细信息的成员可以在登录后进行查看。',
    non_member: '当非会员',
    lookup_inquiry: '联系人查找',
    msg_enter_inquiry_id: '请输入联系人ID。',
    msg_enter_password_when_registering_your_inquiry:
      '当你调用注册请输入你设置的密码。',
    frequently_asked_questions: '常问问题',
    msg_enter_your_password: '请输入您的密码。',
    pls_search_fap: '请搜索问题。',
    msg_source_filename_none: '没有附图。',
    super_inquiry: '最佳',
  },
  modal: {
    not_seeing_day: '白天没见',
  },
  login_guide_modal: {
    title: '资讯中心',
    sub_title: '会员登录系统将被改造，以便会员能够顺利使用交易所。',
    content:
      '[变更前] <br/> 首次注册时创建的ID登录名 <br/><br/>[变更后] <br/> 更改为您的电话号码或电子邮件登录 <br/><br/> 要在重组登录系统之前登录，只需使用首次注册时创建的ID进行登录。',
  },
  affiliate: {
    affiliate_occur_list: '津贴发生明细',
    affiliate_adjust_list: '津贴清算明细',
    allowance_balance_asset: '各资产津贴余额',
    list_allowance_balance_asset: '各资产津贴余额目录',
    search_by_asset: '按资产搜索',
    allowance_search: '按津贴对象搜索',
    generator: '发行人',
    beneficiary: '受惠人',
    benefactor: '施惠人',
    behavior_type: '行为类型',
    target_unique_number: '目标唯一编号',
    date_of_occurrence: '发生日期',
    application_policy_name: '适用政策名',
    beneficiary_type: '受惠人 类型',
    benefactor_type: '施惠人 类型',
    target_amount: '本金对象',
    principal_amount: '本金',
    allowance: '津贴',
    allowance_assets: '津贴资产',
    allowance_amount: '津贴额',
    affiliate_log: '津贴记录',
    allowance_settlement: '津贴结算',
    allowance_settlement_info: '津贴结算信息',
    name_asset_settled: '待结算资产名称',
    balance_receive_payment: '待付余额',
    select_account_settled: '选择要结算的帐户',
    no_affiliate_log: '没有津贴明细',
    no_affiliate_balance: '没有按资产分类的备抵余额清单。',
    no_affiliate_adjust: '没有津贴支付历史。',
    asset_name: '资产名称',
    asset_code: '资产代码',
    balance: '余额',
    cumulative_amount: '累计量',
    please_select_account: '请选择一个帐号',
    calculate: '计算',
    settle: '解决',
    calculate_amount: '结算金额',
    account_number: '账号',
    registration_date: '登录日',
    number: '号码',
  },
  coin_name: '硬币名称',
  main_function: '主功能',
  disclosure_ing: '在...的过程中',
  quick_service: '快捷服务',
  new_account: '新账户',
  social_login: '社会登入',
  way_to_find: '位置',
  cocobank_korea_head_office: 'ONETETHER韩国总行',
  cocobank_branch_office: 'ONETETHER新沙支店',
  address_head_office: '首尔江南区彦州路528',
  address_branch_office: '首尔特别市江南区农贤路803',
  map: '地图',
  korean_language_counseling: '韩国语咨询',
  hours_of_business: '韩国时间10:00至19:00(银行假期除外)',
  overseas_consultation: '海外咨询',
  email_consultation: '邮件咨询',

  exchange_price: '兑换/行情',
  market_price_check: '行情查询',
  full_account_inquiry: '总账户查询',
  exchange_details_check: '兑换记录查询',
  cryptocurrency_exchange_history: '兑换记录',
  deposit_account_inquiry: '资金储备账户查询',
  transfer_result_check: '转账结果查询',
  dormant_account_check: '休眠账户查询',
  account_and_other_case_status: '检查ONETETHER帐户和其他案件状态',
  account_and_other_wallet: 'ONETETHER账户和篷布视图',
  account_search: 'ONETETHER账户查询',
  other_wallet_search: '其他钱包转移',
  error_remittance: '同意在ONETETHER中返回错误汇款',
  transfer: '转账',
  other_wallets_transfer: '其他钱包/转账结果查询',
  other_wallets_transfer_search: '其他钱包转账结果查询',
  frequently_used_accounts: '注册/管理常用帐户',
  new_demand_account: '新活期账户',
  new_installment_savings_account: '新分期储蓄帐户',
  new_deposit_account: '新的定期存款帐户',
  check_account_progress_account: '查看帐户的新帐户进度状态',
  download: '下载',
  withdrawal: '取款',
  Smart_window_withdrawal: '智能窗口退出',
  smart_ATM_withdrawal: '智能ATM取款',
  customer_service: '客户服务',
  notice: '公告',
  one_one_inquiry: '1：1咨询',
  inquiry_details: '咨询记录',
  frequently_asked_questions: '经常问的问题',
  server_notice: '服务器通知',

  service_hours: '客户服务营业时间',
  all_day_long: '（可24小时咨询)',
  online_service_hours: '在线使用ONETETHER时间',
  unusable_hours: '24小时 年中无休 (23:30 - 24:00 不可使用)',
  offline_hours: '离线使用银行时间',
  offline_bank_hours: '(周末和节假日除外)',

  management: '管理',
  secure_management: '安全认证/管理',
  fund_limit_management: '资金限额管理',
  issue_details_check: '问题详细信息检查',
  part_of_news: '这是新闻的一部分。',
  part_of_notice: '这是公告的一部分。',
  full_menu: '全菜单',
  individual: '个人',
  key_coin: '将加密货币连接到真正货币的ONETETHER的主要货币',
  limitation_info: '有关限制限额的信息，以防止损害电信财务欺诈',
  limitation_info_1:
    '由于非面对面的帐户开设，通过自动设备和互联网进行的提款（转账）限制为每天{0} CCF。',
  limitation_info_2:
    '可以向分支机构提供用于确认交易目的的客观身份验证数据，并且可以在“管理>安全身份验证/管理”中取消限制。',
  limitation_info_3: '使用网上银行时，必须注册一个提款帐户才能进行转账交易。',
  limitation_info_4: '每个加密货币限制只能开设5个帐户。',
  limitation_notice: '注意',
  limitation_notice_1:
    '注册网上银行可以在开立存取款账户后，在完成画面上联动申请。',
  limitation_notice_2:
    '现有的网上银行注册客户，请注意，只有在取款账户登陆区分为互联网+分行时，才能通过网上银行登录取款账户。',
  limitation_notice_3:
    '您必须安全身份验证，以确保您更容易向网上银行进行转移。认证过程后，请改善评级，并继续进行会计系统的会计和安排。',

  new_subscription: '注册',
  new_subscription1_1: '点击注册，会发放会员固有的',
  new_subscription1_2: 'ONETETHER专用账户及外部钱包联动的汇款地址。',
  new_subscription2_1:
    '汇款前一定要知道！在ONETETHER专用账户之间转账，不收取任何手续费。注册时发行的账户/地址只有',
  new_subscription2_2:
    '才能汇款。如果试图将其他数字资产存入该地址，可能发生的错误/损失将无法恢复。确认后，通过汇款流程反映到余额中。汇款过程会自动进行，根据网络情况所需时间会有所不同。上述地址是汇款专用地址。',
  new_subscription3_1: '会员可以',
  new_subscription3_2: '汇款。',
  new_subscription4: '您是否同意并理解以上内容？',

  created_account_number: '创建帐号',
  cocobank_exclusive_account: 'ONETETHER 专用帐号',
  depositing_external_wallet: '从外部钱包存入ONETETHER时',
  use: '使用',
  we_future: '我们的未来',
  pop_cocobank: 'ONETETHER',
  fourth_industry: '第四产业的领导者',
  oc_15: '十月15',
  officially_open: '正式开放！',
  head_branch_office: '韩国总公司（蚕室店）/第一分店（新沙店）',
  sep_15: '9月15日下午5点',
  open_popup: '打开',
  thanks_for: '谢谢您的鼓励。',

  direct_exchange: {
    sell_buy_assets: '出售和购买的资产',
    replace_assets: '要更换的资产',
    ccm_exchange_rate: 'CCM持有优惠汇率',
    buy_sell_percent: '买-10％卖+ 10％',
    expected_property: '预期属性',
    preferential_property: '优先资产',
  },

  event_banner: {
    clap: '请用ONETETHER的<span class="color-common">CLAP</span>保存加密货币',
    month_hotcoupon: '查看本月的 HOT优惠券。',
    hotcoupon_sub: '从汇率到各种会员优惠券！',
    grab_bug: '捕捉错误',
    grab_bug_sub: '请在1:1咨询处留言，我们将通过抽签赠送奖品。',
    event2_sub_title: '人生第一笔',
    event2_title: '<span style="font-weight: 700">CCM</span> 分红',
    event2_text:
      '只要<span style="font-weight: 700">加入</span>就给<span style="font-weight: 700">分红</span><br>只要<span style="font-weight: 700">升级</span><br><span style="font-weight: 700">手续费</span>就<span style="font-weight: 700">会降低</span><br>给很多<span style="font-weight: 700">分红</span>的<span style="font-weight: 700">商品</span><br>与<span style="font-weight: 700">CCM</span>的<span style="font-weight: 700">首次会面</span>',
    event2_btn: '注册',
  },
  news_lists: {
    news_list_1:
      '프라비코, iq옵션과 같은 방대한 트렌젝션을 일으키는 거래소가 될 것',
    news_list_2:
      'GCC 코인 10월 15일 포블게이트에 상장. 비트코인처럼 안정화 된 코인이 목표',
    news_list_3: '프라비코, 의료산업에 블록체인 기술 접목한다',
    news_list_4: '디파이 열풍! 그 명과 암',
    news_list_5:
      '은행을 대체할 수 있을까? 블록체인 보관과 검증은 어떻게 이루어지나',
    news_list_6: '블록체인은 식품 유통에 혁신적인 발전을 가져올 것이다',
    news_list_7: '가장 혁명적인 화폐 비트코인 탄생 배경은?',
  },
  pop_notice: {
    notice_close: '关闭',
    notice_today: '今天不看',
  },
  clap: {
    getting_started_clap: '初始设置方法',
    how_to_initialize_clap: '初始化方法',
    getting_started_ledger_live: 'Ledger Live设置法',
    install_coin_app: 'coin app 联动',
    start_text_1:
      '1. 请使用与CLAP同封的USB连接器连接到电脑后，如显示“Welcome”文字，就是新产品。',
    start_text_2:
      '2.请按下右键,当显示‘Set up as New Device’时 请同时按上端两个按钮。',
    start_text_3:
      '3.确认‘Chose a PIN code’文字后， 会出现输入8位pin码的页面，并按两边按钮设置pin码。',
    start_text_4:
      '4.pin码设置完成后,会显示Confirm PIN code，请按两边按钮,再次输入pin码。',
    start_text_5:
      '5.pin码设置完成后，按右键，会显示24个句子中的第一句，请根据上边显示的号码，把代码填写在复原卡背面。',
    start_text_6: '6.填写完成后，请输入与数字相符的1到24的复原代码。',
    start_text_7:
      '7. 如显示Press both buttons to Continue时，请按上端两侧的按钮进行。',
    init_text_1: '1.初始化开始前,首先,请确认是否有重要复原卡和恢复码。',
    init_text_2:
      '2.初始化方法有两种，第一种，如果PIN code连续错3次就会自动初始化。',
    init_text_3:
      '3.第二种，请将CLAP连接到PC，输入PIN code解锁，然后进行Settings > Security > Reset All。',
    init_text_4: '4.请在Cancel和Reset All中再次按Reset All进行初始化。',
    init_text_5: '5.请输入PIN code完成初始化。',
    init_text_6: '6.初始化完成。',
    ledger_live_text_1: '1.请输入start.ledgerwallet.com 网址。',
    ledger_live_text_2:
      '2.请在Step 1中点击Ledger Live app，安装适合的手机,电脑的app。',
    ledger_live_text_3: '3.显示Welcome to Ledger Live时，请点击Get Started进行',
    ledger_live_text_4:
      '4.会显示四项选择，购买CLAP进行的顾客可以选择第一项，其他可以根据顾客的情况选择。',
    ledger_live_text_5: '5.在完成CLAP初始设置后,请选择第三项',
    ledger_live_text_6: '6.在三项选择中选择Ledger Nano S后，点击Continue。',
    ledger_live_text_7: '7.会出现三种核对列表，可根据顾客情况设定。',
    ledger_live_text_8: '8.请确认核对列表后，按第三个Check Now。',
    ledger_live_text_9:
      '9.请连接电脑和CLAP，解除CLAP锁定。（这是确认正品过程）',
    ledger_live_text_10:
      '10.如在第三个核对列表中正品确认(Your device is genuine)的话，请按右下角的continue。',
    ledger_live_text_11:
      '11.会出现设置密码页面，设不设置密码都可以，需要设置密码的人，输入密码后请按右下角的continue/要跳过的人请按skip this step。',
    ledger_live_text_12: '12.请按右下角的continue进行。',
    ledger_live_text_13: '13.Ledger Live的设置完成了。',
    coin_app_text_1:
      '1. 请打开之前设置的Ledger Live，点击中央的Go to Manager。',
    coin_app_text_2: '2. 请将CLAP连接到PC，并输入PIN CODE。',
    coin_app_text_3: '3. 请输入PIN CODE后，请同时按上端两端按钮进行操作。',
    coin_app_text_4:
      '4. 请在下端找出顾客持有的加密货币，并按右侧的 Install进行联动。',
    detail_to_buy: '详细及购买处',

    detail_content1_1: 'CLAP是构成用户的加密货币组合，意味着安全的保护资产。',
    detail_content1_2:
      '世界金融产业通过新技术的发现和革新正在快速移动。加密货币也随着变化和应用，许多跨国公司再次关注加密货币的价值。',
    detail_content1_3:
      '由于特性是电脑等信息形态的残留，没有实物，只在网络上使用的加密货币，长期拥有很多加密货币的使用者对资产的安全性有了更多的苦恼。',
    detail_title_2: 'CLAP提供的服务是确实的',
    detail_content2_1:
      'ONETETHER认为在CLOUD保管的个人钥匙的软件钱包在外部因黑客等会发生安全问题。建议使用解决这些问题的加密货币专门钱包CLAP。',
    detail_content2_2:
      'CLAP最多支持8种应用程序，可以安全地保管比特币、以太坊、USDT等多种加密货币。另外，因为不是经常连接到网络上的钱包，所以可以从外部黑客那里安全地保护资产。',
    detail_title_3: '安全性',
    detail_content3_1:
      'CLAP是为了解决现有的Hot-wallet的安全问题，与全球加密货币专门安全解决方案的法国企业“Ledger”合作制作了Cold-wallet。',
    detail_content3_2:
      'CLAP适用了数字安全知识和经验的130名以上全球工程师建立的安全解决方案。插入护照和信用卡使用的最新安全PIN代码芯片，加强了安全性 ',
    detail_content3_3:
      '即使丢失CLAP，只要有复原卡，就可以通过新的CLAP机器安全地保管使用者持有的资产。',
    detail_title_4: '便利性 ',
    detail_content4_1: '可以使用CLAP上端的两个按钮输入Secret key。',
    detail_content4_2:
      '考虑到用户的便利性 支持包括Bitcoin、Ethereum、XRP等40多个加密货币 。',
    detail_title_6: 'A/S',
    detail_content6_1: '对产品的售后服务是1年。 ',
    detail_content6_2: '如果需要A/S，请拿着CLAP主机到ONETETHER ',
    detail_content6_3:
      '为了A/S，必须要有CLAP背面的序列号。损坏或删除序列号的话，将无法使用售后服务。 ',
    detail_content6_4:
      '由于本人的疏忽产生产品的瑕疵及根据产品的状态可能无法进行售后服务。',
    detail_title_7: '注意事项',
    detail_content7_1: 'CLAP的线上服务是Ledger公司提供的，与ONETETHER无关。 ',
    detail_content7_2:
      '使用产品时，由于本人的疏忽（产品丢失、复原及PIN代码泄露、连接感染的PC）而发生的外部黑客问题，请注意ONETETHER没有责任。',
    detail_content7_3:
      '再次强调，由于“LEDGER LIVE”或Ledger提供的网络服务，使用者获得的金钱损益与ONETETHER无关。',
    detail_title_8: '采购处',
    detail_content8_1: 'co.u co.u（咖啡店）： 首尔市江南区彦州路 430 1楼',
    detail_title_9: '售后服务处',
    detail_content9_1: 'ONETETHER：首尔市江南区彦州路 528 2楼 ',
    detail_content9_2:
      '产品相关的咨询事项可以在附近的CO.U CO.U咖啡店，或者通过help@cocobnk.com邮件咨询。',
  },
}
